export const QTI_DOWNLOAD_RECORDED_EVENT = 'qti-package-download-recorded';
